
<div class="modalMain" *ngIf="data.type !== 'select-powertrain-system'">
    <header class="modalTitle">
        <span class="h2">Select <b>Sub-System</b></span>
    </header>
    <div class="modalBody">
        <mat-radio-group id="subsystemRadio" class="radio-grp" [(ngModel)]="selectedOption" required>
            <mat-radio-button class="fontSize" *ngIf="tabID_1" value="rotating_asset">Rotating Asset</mat-radio-button>
            <mat-radio-button class="fontSize" *ngIf="tabID_2" value="boiler">Eboiler</mat-radio-button>
            <mat-radio-button class="fontSize" *ngIf="tabID_3" value="energy_meter">Energy Meter</mat-radio-button>
            <mat-radio-button class="fontSize" *ngIf="tabID_4" value="transformer">Transformer</mat-radio-button>
            <!-- <mat-radio-button class="fontSize" *ngIf="tabID_1 && ((productionKey && (clientId==390 || clientId==4 || clientId==459 || clientId==258)) || !productionKey)" value="powertrain">PowerTrain</mat-radio-button> -->
            <mat-radio-button class="fontSize" *ngIf="data.isPowertrainEnabled" value="powertrain">PowerTrain</mat-radio-button>
            <!-- <mat-radio-button class="fontSize" *ngIf="!productionKey" value="cyclinder">Cylinder</mat-radio-button> -->
            <mat-radio-button class="fontSize" *ngIf="tabID_7" value="oven">Oven System</mat-radio-button>
            <mat-radio-button class="fontSize" *ngIf="clientId==664" value="piezeo">Piezo</mat-radio-button>
        </mat-radio-group>

    </div>
    <div class="modalFooter">
        <button mat-raised-button color="primary" type="button" [disabled]="!selectedOption" (click)="onClickContinue()">Continue</button>
        <button mat-stroked-button color="warn" type="button" (click)="onclickclose()">Close</button>
    </div>
</div>

<div class="modalMain" *ngIf="data.type==='select-powertrain-system'">
    <header class="modalTitle">
        <span class="h2">Select <b>Powertrain Type</b></span>
    </header>
    <div class="modalBody">
        <mat-radio-group id="subsystemRadio" class="radio-grp" [(ngModel)]="selectedPowertrainOption" required>
            <mat-radio-button class="fontSize"  value="emsaver">Emsaver</mat-radio-button>
            <mat-radio-button class="fontSize"  value="piezeo">Hybrid</mat-radio-button>
        </mat-radio-group>

    </div>
    <div class="modalFooter">
        <button mat-raised-button color="primary" type="button"  (click)="onPowertrainSelectionComplete()">Continue</button>
        <button mat-stroked-button color="warn" type="button" (click)="onClosePowertrainDialog()">Close</button>
    </div>
</div>